import React, { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "web/components/AlertModal";
import { Table } from "reactstrap";
import { TableSection } from "../myOrderStyled";
import { downloadFile } from 'redux/actions/helper/downloadFile';
import * as moment from "moment";
import ConfirmationModal from "web/components/ConfirmationModal";
import UploadDummy from "web/assets/images/UploadDummy.png";
import { AiOutlineArrowDown, AiOutlineArrowUp, AiOutlineVerticalAlignMiddle } from "react-icons/ai";
import { stateConvert } from "web/components/utils/stateAbbreviation";
import { deliveryReqOrderDeclineApi } from "redux/actions/myPickupOrders"
import { pickupOrderDeclineApi } from "redux/actions/myPickupOrders"
import WithdrawIcon from "web/assets/images/withdraw-icon.png";
import Tooltip from "@material-ui/core/Tooltip";

function ScheduledPostsTable(props) {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');
  const sortState = props?.scheduledPostsSortState
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()

  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  const [alertType, setAlertType] = useState();
  const [modalResult, setModalResult] = useState("");
  const toggleModal = () => setAlertModal(!alertModal);

  const [selectedOrderDetails, setSelectedOrderDetails] = useState();
  const [confirmationComment, setConfirmationComment] = useState("");
  const [yesNomodal, setYesNoModal] = useState(false);
  const [yesNoModalContent, setYesNoModalContent] = useState("");
  const [yesNoModalAlertType, setYesNoModalAlertType] = useState();

  const headerArray = [
    { title: 'Req. Del/Pickup Date', sort: true, sortColumn: 'RDD' },
    { title: 'PO#' },
    { title: 'Order Number' },
    { title: 'Location Name', sort: true, sortColumn: 'LOCATION_NAME' },
    { title: "Address - City, ST" },
    { title: 'Type' },
    { title: 'Qty, Order Type' },
    { title: "Status" },
    // { title: 'Need Posted/Tendered Date' },
  ]

  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + ', NA'

    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join(", ")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let size = "";
    let grade = "";
    let LWH
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + ", " + LWH + "-" + condition
      } else {
        return totalQuantity + ", " + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size)
        size = ", " + items?.palletDetails?.size

      if (items?.palletDetails?.grade)
        grade = ", " + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      return totalQuantity + "" + size + "" + grade + ", " + palletType + "-" + condition
    }
  }

  const downloadSpecFiles = async (imagePath) => {
    dispatch(downloadFile(imagePath));
    // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    // window.open(fileUrl);
  };

  const callOrderPageFunc = (items) => {
    if (items?.requestType === 'PickUp') {
      let value = 0
      if (items.orderStatus?.includes('PENDING')) return
      else if (items.orderStatus?.includes('ASSIGNED') || items.orderStatus?.includes('RESCHEDULED')) value = 1
      else if (items.orderStatus?.includes('PICKEDUP') || items.orderStatus?.includes('HOLD')) value = 2
      else if (items.orderStatus?.includes('COMPLETE')) value = 3
      else if (items.orderStatus?.includes('CANCELLED')) value = 4
      else if (items.orderStatus?.includes('CLAIM')) value = 5
      localStorage.setItem('redirectPickupOrderTabValue', value)
      localStorage.setItem('redirectedOrderValue', (items?.orderNo || items?.orderRefNumber || ''))
      history.push('/my-pickup-orders')
    } else if (items.orderStatus?.includes('REQUESTED') || items.orderStatus?.includes('POSTED')) {
      history.push('./my-posted-pallet-needs')
    } else {
      let value = 0
      if (items.orderStatus?.includes('ASSIGNED') || items.orderStatus?.includes('RESCHEDULED') || items.orderStatus?.includes('SHIPPED')) value = 1
      else if (items.orderStatus?.includes('DELIVERED')) value = 2
      else if (items.orderStatus?.includes('COMPLETE')) value = 3
      else if (items.orderStatus?.includes('CANCELLED')) value = 4
      else if (items.orderStatus?.includes('CLAIM')) value = 5
      localStorage.setItem('manageOrderTabFromPtPlusScheduledPost', value)
      localStorage.setItem('redirectedOrderValue', (items?.orderNo || items?.orderRefNumber || ''))
      let myOrderSelectedPageObj = { myOrderSelectedPage: 1, }
      dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
      history.push('./my-orders')
    }
  }

  const setSortStateFunction = (column, value) => {
    let nextType
    if (value === 'normal') nextType = 'ASC'
    else if (value === 'ASC') nextType = 'DESC'
    else if (value === 'DESC') nextType = 'normal'

    let newSortState = {
      sortColumn: column,
      sortValue: nextType
    }
    props.fetchDataCallBack(newSortState, 'sortingChange')
  }

  const sortIconStyle = {
    height: '22px',
    width: '28px',
    color: '#61b01f'
  }

  const getStatusClassName = (items) => {
    let isRedBgRequired = false
    if (items?.orderStatus === 'ASSIGNED' || items?.orderStatus === 'PENDING' || items?.orderStatus === 'SHIPPED') isRedBgRequired = true
    let requestedDate = items?.requestType === 'PickUp' ? items.requestDeliveryDate
      : items?.ptPostedDetailsDTO ? items?.ptPostedDetailsDTO?.requestDeliveryDate
        : items.requestDeliveryDate
    if (isRedBgRequired && requestedDate && moment(requestedDate).isBefore(moment(), 'day')) return "EXPIRED";
    return items?.orderStatus;
  }

  const withdrawRequestOrderConfirmation = (items) => {
    setYesNoModalContent(items?.requestType === 'PickUp' ? 'Are you sure you want to withdraw the pickup order request?' : 'Are you sure you want to withdraw the order request?');
    setYesNoModalAlertType(items?.requestType === 'PickUp' ? 'withdrawPickupRequestOrder' : 'withdrawRequestOrder')
    setYesNoModal(true);
  }

  const withdrawRequestOrderFunction = async (confirmationAlertType) => {
    let data = {
      locationId: null,
      tenderId: selectedOrderDetails?.tenderId,
      comment: confirmationComment ?? null,
      tenderStatus: 'WITHDRAW'
    }
    let response
    if (selectedOrderDetails?.requestType === 'PickUp') {
      response = await dispatch(pickupOrderDeclineApi(data, token));
    } else {
      response = await dispatch(deliveryReqOrderDeclineApi(data, token));
    }
    if (response?.success) {
      setSelectedOrderDetails()
      setAlertModalContent(confirmationAlertType === 'withdrawPickupRequestOrder' ? 'Pickup order request withdrawn successfully!' : 'Order request withdrawn successfully!')
      setAlertType('success')
      toggleModal();
      setModalResult('successWithdraw')
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setAlertModalContent(response?.data?.error?.message || response.message || 'Someting went wrong, please try again in some time.');
        toggleModal();
      }
    }
  }

  return (
    <TableSection>
      <Table responsive>
        <thead>
          <tr>
            {headerArray.map((items, index) => (
              <th key={index} style={{ whiteSpace: items.sort ? 'nowrap' : 'normal' }}>
                {items.title}
                {items.sort && (() => {
                  const isDescending = sortState.sortColumn === items.sortColumn && sortState.sortValue === 'DESC';
                  const isAscending = sortState.sortColumn === items.sortColumn && sortState.sortValue === 'ASC';

                  if (isDescending) {
                    return <AiOutlineArrowDown onClick={() => setSortStateFunction(items.sortColumn, 'DESC')} style={sortIconStyle} />;
                  } else if (isAscending) {
                    return <AiOutlineArrowUp onClick={() => setSortStateFunction(items.sortColumn, 'ASC')} style={sortIconStyle} />;
                  } else {
                    return <AiOutlineVerticalAlignMiddle onClick={() => setSortStateFunction(items.sortColumn, 'normal')} style={sortIconStyle} />;
                  }
                })()}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.pagedata?.map((items, index) => (
            <>
              <tr key={0} className={accordionOpenIndex === index ? 'blue-bg' : ''}>
                <td>
                  {items?.requestType === 'PickUp' ?
                    <>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</>
                    :
                    items?.ptPostedDetailsDTO ?
                      <>{moment(items?.ptPostedDetailsDTO?.requestDeliveryDate).format('MM/DD/YYYY')}</>
                      :
                      <>{moment(items.requestDeliveryDate).format('MM/DD/YYYY')}</>}
                </td>
                <td>{items.poNumber}</td>
                <td>{items.orderNo && items.orderNo !== '' ? items.orderNo : 'NA'}</td>
                <td>{items?.ptPostedDetailsDTO && items?.ptPostedDetailsDTO?.shippingAddress ? `${items?.ptPostedDetailsDTO?.shippingAddress?.locationName}` : items.addressDTO && `${items.addressDTO.locationName}`}</td>
                <td>
                  {items?.ptPostedDetailsDTO && items?.ptPostedDetailsDTO?.shippingAddress ?
                    `${items?.ptPostedDetailsDTO?.shippingAddress?.street} - ${items?.ptPostedDetailsDTO?.shippingAddress?.city}, ${stateConvert(items?.ptPostedDetailsDTO?.shippingAddress?.state) || items?.ptPostedDetailsDTO?.shippingAddress?.state} `
                    :
                    items.addressDTO && `${items.addressDTO.street} - ${items.addressDTO.city}, ${stateConvert(items.addressDTO.state) || items.addressDTO.state} `}
                </td>
                <td>{items?.requestType === 'PickUp' ? 'Pickup' : 'Delivery'}</td>
                <td>{orderType(items)}</td>
                <td className='expand-collapse-class'>
                  {items?.orderStatus === 'PENDING' &&
                    <div>
                      <button
                        title="Withdraw Request"
                        className='withdraw-action-btn'
                        onClick={(e) => {
                          withdrawRequestOrderConfirmation(items)
                          setSelectedOrderDetails(items)
                        }}
                      >
                        <img src={WithdrawIcon} alt="withdraw" />
                      </button>
                    </div>
                  }
                  <div
                    className={`status-class ${getStatusClassName(items)}`}
                    onClick={() => {
                      callOrderPageFunc(items)
                    }}
                  >
                    <p>{items.orderStatus === 'CANCELLED' ? 'CANCELED' : items.orderStatus}</p>
                    {(items?.requestType === 'PickUp' && items.orderStatus?.includes('PENDING')) ? '' : <span>{`>`}</span>}
                  </div>
                  {(accordionOpenIndex === index) ? <h4 onClick={() => setAccordionOpenIndex()}><i></i></h4>
                    : <h5 onClick={() => setAccordionOpenIndex(index)}><i></i></h5>}
                </td>
              </tr>
              {accordionOpenIndex === index &&
                <>
                  <tr className='order-details-wrapper'>
                    <td colspan="1">
                      <div>
                        <h6>Customer</h6>
                        <p>{items.addressDTO?.name}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Ref No</h6>
                        <p style={{ whiteSpace: 'nowrap' }}>{items.orderRefNumber || 'NA'}</p>
                      </div>
                    </td>
                    <td colspan="2">
                      <div>
                        <h6>Supplier Name - City, State</h6>
                        <p>{items?.tenderDetails ?
                          `${items?.tenderDetails.postedTo} - ${items?.tenderDetails.city}, ${stateConvert(items?.tenderDetails.state) || items?.tenderDetails.state}`
                          : 'NA'
                        }</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Supplier Email</h6>
                        <Tooltip
                          placement="top"
                          arrow
                          title={items?.tenderDetails?.email ? items?.tenderDetails?.email?.join(', ') : 'NA'}
                          enterTouchDelay={5}
                          leaveTouchDelay={10000}
                        >
                          <p style={{ whiteSpace: 'nowrap' }}>{items?.tenderDetails?.email ? items?.tenderDetails?.email[0] : 'NA'}</p>
                        </Tooltip>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6 style={{ whiteSpace: 'nowrap' }}>Supplier Phone No</h6>
                        <Tooltip
                          placement="top"
                          arrow
                          title={(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber?.join(', ') : 'NA'}
                          enterTouchDelay={5}
                          leaveTouchDelay={10000}
                        >
                          <p>{(items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? items?.tenderDetails?.phoneNumber[0] : 'NA'}</p>
                        </Tooltip>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Supplier Price</h6>
                        {(items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice?.length >= 1) ?
                          <Tooltip
                            placement="top"
                            arrow
                            title={items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ')}
                            enterTouchDelay={5}
                            leaveTouchDelay={10000}
                          >
                            <p>{items?.tenderDetails?.vendorPrice?.length > 1 ? 'Multi' : items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(', ')}</p>
                          </Tooltip>
                          :
                          'NA'
                        }
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Tendered Date</h6>
                        <p>
                          {items?.tenderDetails?.tenderDate ? items?.tenderDetails?.tenderDate :
                            (moment(items?.createdAt * 1000).format('MM/DD/YYYY') || 'NA')}
                        </p>
                      </div>
                    </td>

                    {/* <td colspan="1">
                      <div>
                        <h6>Post Name</h6>
                        <p>{items.ptPostedDetailsDTO ? items?.ptPostedDetailsDTO?.postName : 'NA'}</p>
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Posted To</h6>
                        {items?.tenderDetails?.postedTo ?
                          <p>{items?.tenderDetails?.postedTo}</p> :
                          <p>{items?.ptPostedDetailsDTO ? (items?.ptPostedDetailsDTO?.postedTo === "MARKET" ? "MP" : items?.ptPostedDetailsDTO?.postedTo === "GROUP" ? "Group" : "") : 'NA'}</p>
                        }
                      </div>
                    </td>
                    <td colspan="1">
                      <div>
                        <h6>Req. Date</h6>
                        <p>{moment(items.createdAt * 1000).format('MM/DD/YYYY')}</p>
                      </div>
                    </td>
                    {items.specificationFiles?.length > 0 ?
                      <td colspan="3">
                        <div>
                          <h6>Specification Document</h6>
                          {items.specificationFiles &&
                            items.specificationFiles?.map((spectItems, i) => (
                              <div
                                style={{ display: 'flex', marginTop: '7px', cursor: 'pointer' }}
                                onClick={() => {
                                  downloadSpecFiles(spectItems.fileName);
                                }}
                              >
                                <img
                                  style={{ marginRight: "5px" }}
                                  src={UploadDummy}
                                  alt="upload Dummy"
                                />
                                <p>{spectItems.orignalFileName}</p>
                              </div>
                            ))}
                        </div>
                      </td>
                      :
                      <td colspan="2"></td>}*/}
                  </tr>
                </>
              }
            </>
          ))}
        </tbody>
      </Table>
      {props.pagedata && props.pagedata.length === 0 &&
        <div><p style={{ width: '100%', textAlign: 'center', position: 'relative', bottom: '40px' }}>No records found</p></div>
      }
      <AlertModal
        isOpen={alertModal}
        toggle={toggleModal}
        title=''
        content={alertModalContent}
        alertType={alertType}
        link=''
        callBackAlert={(val) => {
          if (modalResult === 'successWithdraw') {
            setModalResult('')
            toggleModal()
            props.fetchDataCallBack('', 'refreshData')
          } else toggleModal()
        }}
      />
      <ConfirmationModal
        isOpen={yesNomodal}
        toggle={() => {
          setYesNoModal(!yesNomodal);
          setConfirmationComment("");
        }}
        onClickHander={(val) => {
          if (val === "no") {
          } else {
            if (yesNoModalAlertType === 'withdrawPickupRequestOrder' || yesNoModalAlertType === 'withdrawRequestOrder') {
              withdrawRequestOrderFunction(yesNoModalAlertType)
              setYesNoModal(!yesNomodal);
              setConfirmationComment('')
            }
          }
        }}
        showCommentText={true}
        content={yesNoModalContent}
        confirmationComment={confirmationComment}
        setconfirmationComment={setConfirmationComment}
      />
    </TableSection>
  )
}

export default ScheduledPostsTable